import View from "../framework/view";
import Server from "../server";
import {Order} from "../bo/order";
import template from "../../pugc/invoice";
import Alerts from "../misc/alerts";

const classname = "invoice-view";

const server = Server.instance();

export class InvoiceView extends View {

    private id: string;

    private order : Order | undefined;

    private type : "Confirmation" | "Tax Invoice" = "Confirmation";

    constructor(id: string) {
        super(classname);
        this.id = id;
        this.init();
    }

    async init() {
        this.order = await server.getOrder(this.id);
        this.update("form");
    }

    protected render0(): JQuery<HTMLElement> {

        const t = this.type == "Confirmation" ? "invoice" : "tax-invoice";

        const data = {
            email: this.order?.buyerInfo?.email,
            type: this.type,
            url: `api/orders/${t}/${encodeURIComponent(this.id)}`
        };

        const out = this.pug(template, data);
        return out;
    }

    async send() {

        const email = this.elt().find("input[name=email]").val() as string;
        if (email) {
            if (this.type == "Confirmation") {
                await server.sendInvoice(this.id, email);
                Alerts.alert(`Confirmation sent to ${email}`);
            }
            if (this.type == "Tax Invoice") {
                await server.sendTaxInvoice(this.id, email);
                Alerts.alert(`Confirmation sent to ${email}`);
            }
        }
    }

    async changeType() {
        // @ts-ignore
        this.type = this.elt().find("select[name='type']").val();
        this.update();
    }
}
View.on(
    "." + classname,
    "click",
    ".send",
    function(that: InvoiceView, event, elt) {
        event.preventDefault();
        that.send();
    });
View.on(
    "." + classname,
    "change",
    "select[name='type']",
    function(that: InvoiceView, event, elt) {
        event.preventDefault();
        that.changeType();
    });
